import { gql } from '@apollo/client';
import { IProjectSpaceType } from 'spw-redux/modules/space_types/types';
import { graphqlClient } from './utils';

export const updateProjectSpaceTypePosition = (
  projectSpaceTypeId: number,
  previousId?: number
) =>
  graphqlClient.mutate<{
    projectSpaceType: IProjectSpaceType;
  }>({
    mutation: gql`
      mutation UpdateProjectSpaceTypePosition(
        $projectSpaceTypeId: ID!
        $previousId: ID
      ) {
        projectSpaceType: updateProjectSpaceTypePosition(
          projectSpaceTypeId: $projectSpaceTypeId
          previousId: $previousId
        ) {
          id
          previousId
          category {
            id
          }
        }
      }
    `,
    variables: {
      projectSpaceTypeId,
      previousId,
    },
  });

export const updateProjectSpaceTypes = (
  projectSpaceTypes: Partial<IProjectSpaceType>[]
) =>
  graphqlClient.mutate<{ updatedProjectSpaceTypes: IProjectSpaceType[] }>({
    mutation: gql`
      mutation UpdateProjectSpaceTypes(
        $projectSpaceTypes: [ProjectSpaceTypeInput!]
      ) {
        updatedProjectSpaceTypes: updateProjectSpaceTypes(
          projectSpaceTypes: $projectSpaceTypes
        ) {
          id
          previousId
        }
      }
    `,
    variables: {
      projectSpaceTypes,
    },
  });

export const reassignProjectSpaceType = (
  projectSpaceTypeId: number,
  categoryId: number
) =>
  graphqlClient.mutate<{ projectSpaceType: IProjectSpaceType }>({
    mutation: gql`
      mutation ReassignProjectSpaceType(
        $projectSpaceTypeId: ID!
        $categoryId: ID!
      ) {
        projectSpaceType: reassignProjectSpaceType(
          projectSpaceTypeId: $projectSpaceTypeId
          categoryId: $categoryId
        ) {
          id
          previousId
        }
      }
    `,
    variables: {
      projectSpaceTypeId,
      categoryId,
    },
  });
